var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSoloDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.736,
    height: 47.757,
    viewBox: "0 0 47.736 47.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40519",
    "data-name": "Path 40519",
    d: "M17.511,20.695H3.184A3.183,3.183,0,0,1,0,17.511V3.184A3.183,3.183,0,0,1,3.184,0H17.511a3.183,3.183,0,0,1,3.184,3.184V17.511a3.183,3.183,0,0,1-3.184,3.184m30.225-3.184V3.184A3.183,3.183,0,0,0,44.553,0H30.225a3.184,3.184,0,0,0-3.184,3.184V17.511a3.184,3.184,0,0,0,3.184,3.184H44.553a3.183,3.183,0,0,0,3.184-3.184m0,27.062V30.246a3.183,3.183,0,0,0-3.184-3.184H30.225a3.184,3.184,0,0,0-3.184,3.184V44.573a3.184,3.184,0,0,0,3.184,3.184H44.553a3.183,3.183,0,0,0,3.184-3.184m-27.042,0V30.246a3.183,3.183,0,0,0-3.184-3.184H3.184A3.183,3.183,0,0,0,0,30.246V44.573a3.183,3.183,0,0,0,3.184,3.184H17.511a3.183,3.183,0,0,0,3.184-3.184",
    fill: "#56aa1c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSoloDevices);
export default __webpack_public_path__ + "static/media/home_solo_devices.385e5eda3ea0a18b4e065c6340682ad5.svg";
export { ForwardRef as ReactComponent };